module.exports = __webpack_public_path__ + "static/media/phone-1.974449a0.png";